export var toClass = (string) => {
  return `.${string}`
}

export var toId = (string) => {
  return `#${string}`
}